import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Send } from 'lucide-react';
import type { ComposedLetter } from '@otc/shared';
import { api } from '../api/client.js';
import { Button } from './ui.js';
import { MailComposeDialog } from './MailComposeDialog.js';

type Preview={recipientName:string;toEmail:string;title:string;attachments:string[];revision:string;letter:ComposedLetter};
export function DocumentMailButton({kind,id}:{kind:'contract'|'reconciliation';id:string}) {
  const [preview,setPreview]=useState<Preview|null>(null),[busy,setBusy]=useState(false),[message,setMessage]=useState(''),[error,setError]=useState('');
  const endpoint=`/api/document-mail/${kind}/${id}`;
  const open=async()=>{setBusy(true);setMessage('');setError('');try{setPreview(await api.get<Preview>(endpoint));}catch(e){setError(e instanceof Error?e.message:'Не удалось открыть отправку');}finally{setBusy(false);}};
  return <>
    <Button variant="secondary" disabled={busy} onClick={()=>void open()}><Send size={15}/>{busy?'Подготовка…':'Отправить на почту'}</Button>
    {message&&<span role="status" className="text-sm text-ink2">{message}</span>}
    {error&&<span role="alert" className="text-sm text-red-700">{error}</span>}
    {preview&&createPortal(<MailComposeDialog title={`Отправить: ${preview.title}`} recipientName={preview.recipientName} toEmail={preview.toEmail} letter={preview.letter} attachments={preview.attachments} onCancel={()=>setPreview(null)} onSend={async letter=>{
      const result=await api.post<{sentTo:string}>(endpoint,{...letter,revision:preview.revision});setPreview(null);setMessage(`Отправлено на ${result.sentTo}`);
    }}/>,document.body)}
  </>;
}
